/**
 * Created by Fernando Torres on 01/02/2018.
 */
import ReportsView from '@/views/app/reports/reports.view'

export default [
  {
    path: 'reports',
    name: 'reports',
    component: ReportsView
  }
]



// WEBPACK FOOTER //
// ./src/router/app/reports/index.js